import isEmpty from "lodash/isEmpty";
import { useEffect, useRef } from "react";
import { useRefinementList } from "react-instantsearch";

export const useFilterOptions = () => {
  const contentApi = useRefinementList({
    attribute: "content",
    operator: "or",
    limit: 100,
  });

  const contentItemApi = useRefinementList({
    attribute: "contentItem",
    operator: "or",
    limit: 100,
  });

  const contentOptionsRef = useRef<string[]>([]);
  const contentItemOptionsRef = useRef<string[]>([]);

  useEffect(() => {
    if (isEmpty(contentOptionsRef.current)) {
      contentOptionsRef.current = contentApi.items.map((el) => el.label);
    }
    if (isEmpty(contentItemOptionsRef.current)) {
      contentItemOptionsRef.current = contentItemApi.items
        .filter((item) => item.value !== "Answer")
        .map((el) => el.label);
    }
  }, [contentApi.items, contentItemApi.items]);

  return {
    contentItemOptions: contentItemOptionsRef.current,
    contentOptions: contentOptionsRef.current,
  };
};
